import imgURL from '../../lib/imgURL';

interface PartnerBrandHeaderOptions {
  isAdmin?: boolean;
  isPartnerMerchant?: boolean;
  merchantId?: number | string | null;
  partnerId?: number | string | null;
}

interface PartnerThemeDetails {
  brandLogo?: string | null;
}

interface PartnerBrandLogoOptions {
  isPartnerPage?: boolean;
  themingDetails?: PartnerThemeDetails | null;
}

const isPartnerLandingContext = (merchantId?: number | string | null): boolean =>
  String(merchantId ?? '') === '0';

const isSameMerchant = (
  merchantId?: number | string | null,
  partnerId?: number | string | null
): boolean => String(merchantId ?? '') === String(partnerId ?? '');

export const isPartnerPage = (pathname?: string | null): boolean =>
  Boolean(pathname?.startsWith('/partner'));

export const getPartnerBrandLogo = ({
  isPartnerPage: isOnPartnerPage,
  themingDetails,
}: PartnerBrandLogoOptions): string => {
  if (isOnPartnerPage) return imgURL['partner-logo'];

  return themingDetails?.brandLogo || imgURL['partner-default-dashboard-logo'];
};

export const shouldShowPartnerBrandHeader = ({
  isAdmin,
  isPartnerMerchant,
  merchantId,
  partnerId,
}: PartnerBrandHeaderOptions): boolean => {
  if (!isPartnerMerchant) return false;
  if (isAdmin) return true;

  return isPartnerLandingContext(merchantId) || isSameMerchant(merchantId, partnerId);
};
